var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"connect-button"}},[_c('vs-button',{staticClass:"align-right",attrs:{"color":_vm.color,"type":"filled"},on:{"click":function($event){return _vm.open()}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }